import PermintaanAsetApi from './PermintaanAsetApi';

export default PermintaanAsetApi;
